import { GroupingFactorWithGroups } from "../ars_ldm";
import { isGroup } from "./isGroup";
import { isNamedObject } from "./isNamedObject";

/**
 * Type guard to check if a value is a GroupingFactorWithGroups.
 *
 * Validates that the object has the required properties of a GroupingFactorWithGroups:
 * - NamedObject properties
 * - id: string
 * - dataDriven: false
 * - groups: Group[]
 *
 * @param obj - The value to check
 * @returns True if the object is a GroupingFactorWithGroups
 */
export const isGroupingFactorWithGroups = (obj: unknown): obj is GroupingFactorWithGroups => {
  // Check NamedObject properties
  if (!isNamedObject(obj)) return false;
  // Check required properties and their types
  const chkObj = obj as GroupingFactorWithGroups;
  if (typeof chkObj.id !== "string") return false;
  if (chkObj.dataDriven !== false) return false;
  if (!Array.isArray(chkObj.groups)) return false;
  if (chkObj.groups.some((group) => !isGroup(group))) return false;
  // Everything is good
  return true;
};
